import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import zhTW from './zh-TW.json';

import { ConstantUtil } from '@/utils/ConstantUtil';

// 導入語言包

const resources = {
  'zh-TW': {
    translation: zhTW,
  },
};

const i18n = createInstance();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: ConstantUtil.DEFAULT_LANGUAGE,
    fallbackLng: ConstantUtil.DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
